<div class="container-fluid">
  <div class="panel-body content-body-pages">
    <div class="user-panel">
      <div class="head-table">
        <span>{{ 'ListOfOrganizations' | translate }}</span>
      </div>
      <div class="row">
        <div class="col-12 tree-column h-100">
          <mat-tree [dataSource]="dataSource"
                    [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node"
                           matTreeNodePadding>
              <button [attr.aria-label]="'Toggle ' + node.Title"
                      class="d-flex justify-content-center align-items-center"
                      mat-icon-button
                      matTreeNodeToggle>
                <img *ngIf="!treeControl.isExpanded(node)"
                     src="/icons/arrow-leftbs.svg">
                <img *ngIf="treeControl.isExpanded(node)"
                     class="arrow-down"
                     src="/icons/arrow-down.svg">
              </button>
              <label> {{ node.Title }}</label>
              <div class="d-flex justify-content-center align-items-center">
                <app-frontend-button (click)="onCreateClicked(node.BusinessId)"
                                     *ngIf="node.Type != 'DORMITORY'"
                                     [class]="'color-create'"
                                     [endpoint]="ServicePath.CREATE_BUSINESSES"
                                     [icon]="'add'"
                                     [title]="'Insert'">{{ 'Insert' | translate }}
                </app-frontend-button>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <app-frontend-button (click)="onUpdateClicked(node)"
                                     [class]="'color-update'"
                                     [endpoint]="ServicePath.UPDATE_BUSINESSES"
                                     [icon]="'edit'"
                                     [title]="'Update'">{{ 'Update' | translate }}
                </app-frontend-button>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <app-frontend-button (click)="onDeleteClicked(node.BusinessId)"
                                     [class]="'color-delete'"
                                     [endpoint]="ServicePath.DELETE_BUSINESSES"
                                     [icon]="'delete'"
                                     [title]="'Delete'">{{ 'Delete' | translate }}
                </app-frontend-button>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <app-frontend-button (click)="onAssignRoleToBusiness(node)"
                                     [class]="'color-person'"
                                     [endpoint]="ServicePath.GET_ROLES"
                                     [icon]="'person'"
                                     [title]="'Roles'">{{ 'Roles' | translate }}
                </app-frontend-button>
              </div>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                           matTreeNodePadding>
              <button [attr.aria-label]="'Toggle ' + node.Title"
                      class="d-flex justify-content-center align-items-center"
                      mat-icon-button
                      matTreeNodeToggle>
                <img *ngIf="!treeControl.isExpanded(node)"
                     src="/icons/arrow-leftbs.svg">
                <img *ngIf="treeControl.isExpanded(node)"
                     class="arrow-down"
                     src="/icons/arrow-down.svg">
              </button>
              <label style="color: black"> {{ node.Title }}</label>
              <app-frontend-button (click)="onCreateClicked(node.BusinessId)"
                                   [class]="'color-create'"
                                   [endpoint]="ServicePath.CREATE_BUSINESSES"
                                   [icon]="'add'"
                                   [title]="'Insert'">{{ 'Insert' | translate }}
              </app-frontend-button>
              <div class="d-flex justify-content-center align-items-center">
                <app-frontend-button (click)="onUpdateClicked(node)"
                                     [class]="'color-update'"
                                     [endpoint]="ServicePath.UPDATE_BUSINESSES"
                                     [icon]="'edit'"
                                     [title]="'Update'">{{ 'Update' | translate }}
                </app-frontend-button>
              </div>
              <app-frontend-button (click)="onDeleteClicked(node.BusinessId)"
                                   [class]="'color-delete'"
                                   [endpoint]="ServicePath.DELETE_BUSINESSES"
                                   [icon]="'delete'"
                                   [title]="'Delete'">{{ 'Delete' | translate }}
              </app-frontend-button>
              <app-frontend-button (click)="onAssignRoleToBusiness(node)"
                                   [class]="'color-person'"
                                   [endpoint]="ServicePath.GET_ROLES"
                                   [icon]="'person'"
                                   [title]="'Roles'">{{ 'Roles' | translate }}
              </app-frontend-button>
            </mat-tree-node>
          </mat-tree>
        </div>
      </div>
    </div>
  </div>
</div>
